import { ThemeColorModeProps } from "../utils/cpds-utils";

export const TextTransforms = {
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase',
  CAPITALIZE: 'capitalize',
  NORMAL: 'normal',
  NONE: 'none',
};

export type StyledTagProps = {
  caseStyle?: 'UPPERCASE' | 'LOWERCASE' | 'CAPITALIZE' | 'NORMAL' | 'NONE';
  state?: 'DEFAULT' | 'DISABLED' | 'UNCLICKABLE';
  filterApplied?: boolean;
};

export interface CpdsTagsProps extends React.HTMLAttributes<HTMLDivElement>, StyledTagProps, ThemeColorModeProps {
  domRef?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
  exClasses?: string;
  styleOverrides?: React.CSSProperties;  
}
